import { Injectable } from '@angular/core';
import { IAuthorizationService } from '../interfaces/authorization.abstract.service';

@Injectable()
export class AuthorizationServiceMock implements IAuthorizationService {
    init() {}

    fetchUserRoles(): any {}

    checkRetrievalStatus(): boolean {
        return false;
    }

    isEntitled(roleExpression: string): boolean {
        return true;
    }

    cleanUp(): void {}
}
